import { useDispatch } from 'react-redux';
import { userActions } from '../../store/user-slice';
import { verifyCookie } from '../../lib/verify-cookies';
import jwt_decode from 'jwt-decode';
import { clientActions } from '../../store/client-slice';


const Logout = () => {
  const dispatch = useDispatch();
  let clientName = 'academicpeds';
  const authCookie = verifyCookie( 'auth_code' );

  if ( !clientName ) {
    const { neonClientName } = jwt_decode( authCookie );
    clientName = neonClientName;
  }

  // Delete cookie
  const date = new Date();
  document.cookie = `neon_access_token=;expires=${date.toGMTString()};domain=${process.env.REACT_APP_DOMAIN}`;
  document.cookie = `auth_code=;expires=${date.toGMTString()};domain=${process.env.REACT_APP_DOMAIN}`;
  // Delete redux
  dispatch( clientActions.clearState( 'CLEAR_SESSION' ) );
  dispatch( userActions.clearState( 'CLEAR_SESSION' ) );
  // Logout neon and redirect
  window.location= `https://${clientName}.app.neoncrm.com/np/logout.do?targetUrl=${process.env.REACT_APP_PROTOCOL}${process.env.REACT_APP_DOMAIN}:${process.env.REACT_APP_PORT}`;

  return null;
};

export default Logout;